module.exports = __webpack_public_path__ + "static/img/can-cranberry.492e852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-cranberry.png
// module id = WcgN
// module chunks = 0